import apiClient from '@shared/api/client';

export const getTopicList = async () => {
  try {
    const res = await apiClient.post('/v1/shadows/topic/list', {});
    return { success: true, data: res };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export const getPostList = async (params = {}) => {
  try {
    const res = await apiClient.post('/v1/interact/jueGuang/post/list', {
      per_page: 20,
      page: 1,
      ...params,
    });
    return { success: true, data: res };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export const getRecordList = async (params = {}) => {
  try {
    const res = await apiClient.post('/v1/shadows/record/list', {
      per_page: 20,
      page: 1,
      ...params,
    });
    return { success: true, data: res };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export const getRecord = async (recordId) => {
  try {
    const res = await apiClient.post('/v1/shadows/record/get', { record_id: recordId });
    return { success: true, data: res };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export const likeRecord = async (recordId, like) => {
  try {
    const res = await apiClient.post('/v1/shadows/record/like', {
      record_id: recordId,
      like,
    });
    return { success: true, data: res };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export const uploadRecord = async ({ username, topic_id, description, image_file, video_file }) => {
  try {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('topic_id', String(topic_id));
    formData.append('description', description);
    if (image_file) formData.append('image', image_file);
    if (video_file) formData.append('video', video_file);
    const res = await apiClient.post('/v1/shadows/file/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return { success: true, data: res };
  } catch (e) {
    return { success: false, error: e.message };
  }
};
